import React, { useEffect, useState } from "react";
import SidebarItem from "../components/SidebarItem";
import "../css/SidebarItem.css";
import DashboardIcon from "../assets/icons/dashboardsvg.png";
import UserIcon from "../assets/icons/users.png";
import ModelIcon from "../assets/icons/modelsvg.png";
import ProductIcon from "../assets/icons/productsvg.png";
import SubscrptionIcon from "../assets/icons/paymentsvg.png";
import EnterpriseIcon from "../assets/icons/enterprisesvg.png";
import ModuleIcon from "../assets/icons/modulesvg.png";
import botIcon from "../assets/img/Faviicon.png";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedMenu, setRefreshSidebar } from "../redux/sidebarSlice";
import axios from "axios";
import Logo from "../assets/img/ThinkStore_Login.png";

const SuperAdminSidebar = ({ expanded, toggleSidebar }) => {
  const dispatch = useDispatch();
  const [dynamicModules, setDynamicModules] = useState([]);
  const refreshSidebar = useSelector((state) => state.sidebar.refreshSidebar);
  const selectedMenu = useSelector((state) => state.sidebar.selectedMenu);

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  const handleMenuClick = (label) => {
    dispatch(setSelectedMenu(label));
  };

  const fetchModules = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/modules`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDynamicModules(res.data);
    } catch (err) {
      console.error("Failed to fetch modules for sidebar", err);
    }
  };

  useEffect(() => {
    fetchModules();
    if (refreshSidebar) {
      dispatch(setRefreshSidebar(false));
    }
  }, [refreshSidebar]);

  return (
    <div
      className={`sidebar d-flex flex-column justify-content-between ${
        expanded ? "expanded" : "collapsed"
      }`}
      style={{ height: "100vh" }}
    >
      <div>
        <div
          className={`logo-section ${
            expanded
              ? "d-flex justify-content-between align-items-center px-3"
              : "d-flex align-items-center justify-content-center gap-2 py-2"
          }`}
        >
          {/* <img
                // src="/asset/logo.png"
                //  src="/thinkstoreicon.png"
                alt="Logo"
                className="logo"
                style={{ width: "110px", height: "30px", objectFit: "contain" }}
              /> */}
          {expanded ? (
            <>
              {/* <img
                // src="/asset/logo.png"
                 src="/thinklogo.png"
                alt="Logo"
                className="logo"
                style={{ width: "110px", height: "30px", objectFit: "contain" }}
              /> */}
              {/* <span className=" fs-5 fw-semibold textcolor" style={{color:"#3493F3"}}> AI ThinkStore</span> */}
              <img
                src={Logo}
                className="w-80 aspect-[5/1] object-cover ml-[-32px]"
                alt="Logo"
              />
              <button onClick={toggleSidebar} className="sidebar-toggler ms-2">
                <i className="bi bi-chevron-double-left" />
              </button>
            </>
          ) : (
            <>
              <img
                src={botIcon}
                alt="Bot Icon"
                className="bot-icon"
                style={{
                  width: "60px",
                  height: "40px",
                  cursor: "pointer",
                }}
              />
              <button onClick={toggleSidebar} className="sidebar-toggler">
                <i className="bi bi-chevron-double-right" />
              </button>
            </>
          )}
        </div>

        <ul className="menu">
          {/* Dynamically Added Modules */}
          {dynamicModules
            .filter((mod) => mod.module_status === "1")
            .map((mod) => (
              <SidebarItem
                key={mod.module_id}
                icon={
                  mod.module_icon
                    ? `${process.env.REACT_APP_SERVER_URL}/${mod.module_icon}`
                    : ModuleIcon
                }
                label={mod.module_name}
                to={`/superadmin/${mod.module_name
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`}
                expanded={expanded}
                onClick={() => handleMenuClick(mod.module_name)}
                active={selectedMenu === mod.module_name}
              />
            ))}

          <SidebarItem
            icon={ModuleIcon}
            label="Module Management"
            to="/superadmin/module"
            expanded={expanded}
            onClick={() => handleMenuClick("Module Management")}
            active={selectedMenu === "Module Management"}
          />
        </ul>
      </div>

      <div className="text-center" style={{ fontSize: "13px", color: "white" }}>
        <p>v1.1.0</p>
      </div>
    </div>
  );
};

export default SuperAdminSidebar;
